import { Component, OnInit, ViewChild, Input, Output, ElementRef, EventEmitter } from '@angular/core';
import { AbstractControl, FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
// import { ValidationService } from '../../../validation.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { CommonModule } from '@angular/common';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-admin-device-list',
  templateUrl: './admin-device-list.component.html',
  styleUrls: ['./admin-device-list.component.scss'],
  standalone:true,
  imports: [CommonModule,MatMenu,MatMenuModule,MatButtonModule,MatIconModule]
})
export class AdminDeviceListComponent implements OnInit {
  private addDeviceMacUrl: any = BaseUrlConstantsService.ADD_DEVICE;
  private inventoryListingUrl = BaseUrlConstantsService.INVENTORYLIST;
  private deviceTypeListingUrl = BaseUrlConstantsService.DEVICE_TYPE_LIST;
  public clientListingUrl = BaseUrlConstantsService.CLIENTS_LISTING;
  clientsList: any = [];
  public deleteInventoryUrl = BaseUrlConstantsService.DELETE_INVENTORY;
  private updateInventoryUrl = BaseUrlConstantsService.UPDATE_INVENTORY;
  public pid: boolean;
  public showList: boolean;
  public emptyMsg: boolean;
  public asc: boolean;
  public selectValueArr = [];
  public deviceTypeID: any;
  public deviceTypeName: any;
  public filterSelection = 'All';
  public filterSelectionTwo = 'All';
  public inventoryArrayList: any = [];
  public showEmptyError: any = '';
  public deviceInventoryList: any;
  totleInventorysonList: any;
  deviceDetailName: any;
  public deviceCategoryId:any;
  is_piezo_gateway=0;
  accociatedClientObj: any;
  public allDeviceList: any;
  public associateButtonON: boolean;
  public deviceArrayList: any = [];
  @ViewChild('macInput') macInput: ElementRef;
  public breadcrumbsArray: any = [{
    page_ref: 'view-device-type',
    page_title: 'device type'
  },
  // {
  //   page_ref: 'devices',
  //   page_title: 'devices'
  // }
];

  public filterList = [{
    title: 'ALL',
    value: '1',
    checked: true
  }, {
    title: 'ASSOCIATED ',
    value: '1',
    checked: false
  }, {
    title: 'UNUSED',
    value: '1',
    checked: false
  }];
  public filterListTwo = [{
    title: 'ALL',
    value: '1',
    checked: true
  }, {
    title: 'HEALTHY',
    value: '1',
    checked: false
  }, {
    title: 'UNHEALTHY',
    value: '1',
    checked: false
  }, {
    title: 'ERROR',
    value: '1',
    checked: false
  }];
  idsResultArr: any = [];
  public today: Date;
  deviceApiUrls:any = [];

  mac=''// if mac is passed

  constructor(
    public router: Router,
    private service: BackendApiService,
    private changeService: ChangeUsersService,
    public activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    private formBuilder: FormBuilder) {
    this.utcTime();
    activeRoute.queryParams.subscribe(params => {
      console.log(params)
      if (params !== undefined) {
        this.deviceTypeID = params[`deviceTypeId`];
        this.deviceTypeName = params[`deviceName`];
        this.deviceDetailName = params[`deviceDetail`];
        this.deviceCategoryId = params[`deviceCategory`];
        this.mac=params[`mac`];
        this.is_piezo_gateway=params['is_piezo_gateway'] || 0
        if (params[`pageRef`] === 'fromDashboard') {
          this.showAllNewInventorys();
        } else {
          this.getAllInventory();
        }
        console.log(this.is_piezo_gateway)
      }
    });
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }


  async showAllNewInventorys() {
    const body = {
      device_type_id: ''
    };
    this.service.postData(this.inventoryListingUrl, body).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.inventoryArrayList = JSON.parse(JSON.stringify(res)).data.body;
        const newValue = this.inventoryArrayList.filter(result => result.status === 'REGISTERED');
        this.deviceInventoryList = newValue;
        this.totleInventorysonList = this.deviceInventoryList.length;
        if (this.inventoryArrayList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    });
  }


  ngOnInit() {
    console.log(localStorage.getItem('user_id'),"useriddevicetypelisting")
    this.deviceAssociate();
    this.getDeviceTypeListing();
    // this.service.loadDeviceCloudApis().then(data => {
    //   this.deviceApiUrls = JSON.parse(JSON.stringify(data));
    // });
  }

  async filterMethod(event) {
    const term = event.trim().toLowerCase();
    this.filterSelection = term;
    this.filterSelectionTwo = 'all';
    if (term === 'all') {
      this.deviceInventoryList = this.inventoryArrayList;
      this.totleInventorysonList = this.deviceInventoryList.length;
    } else {
      const filterValue = this.inventoryArrayList.filter(result => result.status.toLowerCase().indexOf(term) >= 0);
      this.deviceInventoryList = filterValue;
      this.totleInventorysonList = this.deviceInventoryList.length;
    }
  }

  async filterMethodSecond(event) {
    const term = event.trim().toLowerCase();
    this.filterSelection = 'all';
    this.filterSelectionTwo = term;
    if (term === 'all') {
      this.deviceInventoryList = this.inventoryArrayList;
      this.totleInventorysonList = this.deviceInventoryList.length;
    } else {
      const filterValue = this.inventoryArrayList.filter(result => result.health.trim().toLowerCase().indexOf(term) >= 0);
      this.deviceInventoryList = filterValue;
      this.totleInventorysonList = this.deviceInventoryList.length;
    }
  }

  async getDeviceTypeListing() {

    this.service.getData(this.deviceTypeListingUrl + "/" + localStorage.getItem('user_id')).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.deviceArrayList = JSON.parse(JSON.stringify(res)).data.body;
        console.log(this.deviceArrayList);
        this.deviceArrayList.unshift({ name: 'All' });
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

  onGroupSelected(id) {
    if (id === 0) {
      this.deviceInventoryList = this.inventoryArrayList;
      this.totleInventorysonList = this.deviceInventoryList.length;
    } else {
      this.service.getData(this.inventoryListingUrl + "/" + id).then(res => {
        if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          const resNew = JSON.parse(JSON.stringify(res)).data.body;
          this.deviceInventoryList = resNew;
        }
      });
    }
  }

  showDeleteDialog(id, index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      height: '150px',
      data: {
        type: 'delete-dialog-open',
        typeOf: 'user'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.deleteInventory(id, index);
      }
    });
  }

  deleteInventory(id, index) {
    this.service.deleteInfo(this.deleteInventoryUrl + "/" + id).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.message=="Deleted successfully") {
        this.service.showSuccess('Successfully deleted.');
        this.deviceInventoryList.splice(index, 1);
        this.totleInventorysonList = this.deviceInventoryList.length;
        if (this.deviceInventoryList.length === 0) {
          this.showList = false;
          this.emptyMsg = true;
        }
      }
      else if(JSON.parse(JSON.stringify(res)).data.body.message=="Asset or Device is in use"){
        this.service.showError('Asset or Device is in use !');
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

  searchData(ev) {
    this.filterSelectionTwo = 'ALL';
    this.filterSelection = 'ALL';
    const term = ev.toLowerCase();
    if(term==''){
      if (this.macInput) {
      this.macInput.nativeElement.value = '';
    }
    }
    this.deviceInventoryList = this.inventoryArrayList.filter(result => result.mac_address.toLowerCase().indexOf(term) >= 0 || result.name.toLowerCase().indexOf(term) >= 0);
    this.totleInventorysonList = this.deviceInventoryList.length;
    if (this.deviceInventoryList.length === 0) {
      this.showEmptyError = 'No inventory found.';
    } else {
      this.showEmptyError = '';
    }
  }

  async editDevice(typeId, name, macAddress, deviceId, deviceUserId) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        deviceTypeId: typeId,
        deviceTypeName: name,
        deviceMac: macAddress,
        device_user_id: deviceUserId,
        id: deviceId,
        type: 'editInventory'
      }
    };
    this.router.navigate(['/add-device'], navigationExtras);
  }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  async selectListItem(event: any, index: number, id: number) {
    if (event.checked) {
      this.selectValueArr.push(id);
    } else {
      const index1 = this.selectValueArr.indexOf(id);
      if (index1 > -1) {
        this.selectValueArr.splice(index1, 1);
      }
    }
    if (this.selectValueArr.length === 0) {
      this.associateButtonON = false;
    } else {
      this.associateButtonON = true;
    }
  }

  trackByFn(index, item) {
    return item.id;
  }

  getAllInventory() {
    this.service.getData(this.inventoryListingUrl + "/" + this.deviceTypeID).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        console.log(JSON.parse(JSON.stringify(res)));
        if (JSON.parse(JSON.stringify(res)).data.body.body === undefined) {
          this.inventoryArrayList = JSON.parse(JSON.stringify(res)).data.body;
        } else {
          if (JSON.parse(JSON.stringify(res)).data.body.body.length === 0) {
            this.inventoryArrayList = JSON.parse(JSON.stringify(res)).data.body.body;
          } else {
            this.inventoryArrayList = JSON.parse(JSON.stringify(res)).data.body.body;
          }
        }
        this.deviceInventoryList = this.inventoryArrayList;
        console.log(this.mac)
        if(this.mac!=''){
          this.searchData(this.mac)
        }
        this.totleInventorysonList = this.deviceInventoryList.length;
        if (this.inventoryArrayList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    });
  }

  async deviceAssociate() {
    this.service.getData(this.clientListingUrl + "CLIENT").then(res => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.clientsList = JSON.parse(JSON.stringify(res)).data.body;
      }
    });
  }

  async addDevice(typeId, name) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        deviceTypeId: typeId,
        deviceTypeName: name
      }
    };
    this.router.navigate(['/add-device'], navigationExtras);
  }


  addNewInvenDevice(deviceTypeId: any) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '300px',
      maxWidth: '100%',
      data: {
        type: 'addNewInvenDeviceDialogBox',
        //cloud_url: this.deviceApiUrls,
        inventoryData: { device_serial: "", mac_address: "", gateway_url:"", device_category_id:this.deviceCategoryId, device_type_id: deviceTypeId, admin_id: localStorage.getItem("user_id"),master_type:3}
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result.type === 'addNewInvenDeviceDialogBox') {
          if (result.inventoryData.device_serial === undefined) {
            this.service.showError("Device serial can't be empty.");
          } else if (result.inventoryData.mac_address === undefined) {
            this.service.showError("Mac address can't be empty.");
          } else {
            const valNewFreeFromSpace = result.inventoryData.mac_address.split(/\s/).join('');

            let gatewayURL = null;
            if(result.inventoryData.device_category_id==5){
              gatewayURL = result.inventoryData.gateway_url;
            }else{
              gatewayURL = null;
            }

            const body = {
              user_id: localStorage.getItem('user_id'),
              name: result.inventoryData.device_serial,
              mac_address: valNewFreeFromSpace,
              gateway_url: gatewayURL,
              // device_cloud_api:result.inventoryData.cloud_url,
              device_id: this.deviceTypeID,
              device_category_id:this.deviceCategoryId,
              master_type:result.inventoryData.master_type,
              is_piezo_gateway:this.is_piezo_gateway
            };
            this.service.addUserPost(this.addDeviceMacUrl, body).then(res => {
              if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
                const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
                this.service.showError(msgErr);
              } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
                this.service.showSuccess('User mac address registered successfully');
                this.getAllInventory();
              } else {
                this.service.showError('Something went wrong.');
              }
            });
          };
        };
      };
    });
  }



  editInfoNew(obj, i) {
    if (obj.user_id !== "") {
      if (this.clientsList.length !== 0) {
        this.accociatedClientObj = this.clientsList.filter(function (e) {
          return parseInt(e.id) === parseInt(obj.user_id);
        });
      }else{
        this.accociatedClientObj = [];
      }
    }

    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '300px',
      maxWidth: '100%',
      data: {
        type: 'editNewInventoryDIALOG',
        clients: this.clientsList,
        // cloud_url: this.deviceApiUrls,
        inventoryData: {
          // cloud_url:obj.device_cloud_api,
          device_serial: obj.name, mac_address: obj.mac_address, gateway_url:obj.gateway_url, device_category_id:this.deviceCategoryId, device_type_id: this.deviceTypeID, client_id: obj.user_id === "" ? "" : obj.user_id, company_name: this.accociatedClientObj.length === 0 ? "" : this.accociatedClientObj[0].company_name, isClientAssociated: obj.device_status.toUpperCase() === "USED",master_type:obj.master_type }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result.type === 'editNewInventoryDIALOG') {

          let gatewayURL = null;

          console.log(result,'result..')
          if(result.inventoryData.device_category_id==5){
            gatewayURL = result.inventoryData.gateway_url;
          }else{
            gatewayURL = null;
          }
          console.log(gatewayURL,'gatewayURL..')

          const body = {
            user_id: result.inventoryData.client_id,
            device_id: this.deviceTypeID,
            name: result.inventoryData.device_serial,
            mac_address: result.inventoryData.mac_address,
            gateway_url:gatewayURL,
            status: 'associated',
            // device_cloud_api:result.inventoryData.cloud_url,
            admin_id: localStorage.getItem("user_id")
          };
          console.log(body,'body..')
          this.service.putData(this.updateInventoryUrl + "/" + obj.id, body).then(res => {
            if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
              const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
              this.service.showError(msgErr);
            } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
              this.service.showSuccess('Device association successful.');
              this.getAllInventory();
            } else {
              this.service.showError('Asset is already in use !');
            }
          });
        }
      }
    });
  }

  sortByStatus(){
    const priority = {
      'USED': 1,
      'ASSOCIATED': 2
    };
    this.asc=!this.asc;

    this.deviceInventoryList = this.deviceInventoryList.sort((a, b) => {
      const aPriority = priority[a.status] || 99; // default lower priority
      const bPriority = priority[b.status] || 99;
      return this.asc?bPriority - aPriority:aPriority - bPriority;
    })
  }


}
